module.exports = __webpack_public_path__ + "img/caillebotis-electroforges.615f856c.png";